const ColorButton = {
  props: {
    productColorsData: {
      type: Array,
      required: true,
    },
    colorIndex: {
      type: Number,
      required: true,
    },
  },
  methods: {
    onClickColor(index) {
      if (this.colorIndex !== index) {
        this.$emit('handleChangeColor', index);
      }
    },
  },
  template: `
  <ul>
    <li v-for="(item,index) in productColorsData" @click="onClickColor(index)"
        :class="index === colorIndex ? 'active' : null">
        <a href='javascript:;'>
            <img :src="item.PintSizePictureUrl" :alt="item.Name" :title="item.Name" />
        </a>
    </li>
</ul>`,
};

export default ColorButton;
